import * as yup from 'yup';

export const airportTransferInitialValues = {
  airportTransferCost: null,
  airportTransferComments: '',
};
export const validationSchema = yup.object().shape({
  airportTransferCost: yup
    .number()
    .nullable()
    .transform((_, val) => (val === '' ? null : Number(val)))
    .required('Costs is required.')
    .typeError('Costs must be a number')
    .moreThan(0, 'Costs must be greater than 0'),
  airportTransferComments: yup.string(),
});
